import React from 'react';
import PropTypes from 'prop-types';
import { gql, useFragment, useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import useParamsRouter from '../../../hooks/useParamsRouter';
import { CredentialTypeBasicFieldsFragment, GroupingBasicFieldsFragment } from '../../../api/gql/taxi-backend/v1/fragments';

function Rows({ credentialType }) {
  const history = useHistory();
  return credentialType.groupings.map((group) => (
    <tr
      key={group.id}
      id={`grouping-${group.id}`}
      onClick={() => history.push(`/credential-type/${credentialType.id}/groupings/${group.id}/forms`)}
    >
      <td id={`grouping-name-${group.id}`}>{group.name}</td>
      <td id={`grouping-info-${group.id}`}>{group.info}</td>
    </tr>
  ));
}

Rows.propTypes = {
  credentialType: PropTypes.object.isRequired,
};

export const GET_CREDENTIAL_TYPE_SELECTED_GROUPINGS_INFO = gql`
  query GetCredentialTypeSelectedGroupingsInfo($id: Int!, $value: String!) {
    credentialType(id: $id) {
      ...CredentialTypeBasicFieldsFragment
      columnsName @client
      groupings {
        ...GroupingBasicFieldsFragment
        programs
        info @client(value: $value)
      }
    }
  }
  ${CredentialTypeBasicFieldsFragment}
  ${GroupingBasicFieldsFragment}
`;

export function TableGroupingsInfo({ credentialTypeIdInt, credentialTypeValue }) {
  const { data: { credentialType } = {}, loading } = useQuery(GET_CREDENTIAL_TYPE_SELECTED_GROUPINGS_INFO, {
    variables: { id: credentialTypeIdInt, value: credentialTypeValue },
  });

  if (loading) {
    return <div>Loading...</div>;
  }
  const Columns = () => credentialType.columnsName.map((name) => <th key={name} scope="col">{name}</th>);

  return (
    <table className="table table-hover bg-white border">
      <thead>
        <tr className="text-uppercase" style={{ fontSize: '0.75rem' }}>
          <Columns />
        </tr>
      </thead>
      <tbody>
        <Rows credentialType={credentialType} />
      </tbody>
    </table>
  );
}

TableGroupingsInfo.propTypes = {
  credentialTypeIdInt: PropTypes.number.isRequired,
  credentialTypeValue: PropTypes.string.isRequired,
};

export default function CredentialTypeSelected() {
  const { credentialTypeIdInt } = useParamsRouter();

  const { data, complete } = useFragment({
    fragment: CredentialTypeBasicFieldsFragment,
    from: {
      __typename: 'CredentialType',
      id: credentialTypeIdInt,
    },
  });

  if (!complete) {
    return <div className="container">Groupings info...</div>;
  }

  return (
    <div className="container">
      <div className="row mt-4">
        <div className="col-12">
          <TableGroupingsInfo credentialTypeIdInt={credentialTypeIdInt} credentialTypeValue={data.value} />
        </div>
      </div>
    </div>
  );
}
